import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Card, Table } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { Link } from 'react-router-dom'
import Cookies from 'js-cookie'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const CustomerList = ({ newCustomer }) => {
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    // Check for authentication token
    const token = Cookies.get('authToken')
    if (!token) {
      // If token is not found, redirect to login page
      window.location.href = '/login'
    }
  }, [])

  const buttonStyle = {
    transition: 'transform 0.3s ease',
  }
  const buttonHoverstyle = {
    transform: 'scale(1.2)',
  }
  const [isHovered, setIsHovered] = useState(false)

  useEffect(() => {
    const fetchCustomersData = async () => {
      setLoading(true)

      const token = Cookies.get('authToken') // Retrieve token from cookies

      try {
        const response = await axios.get(
          BASE_URL+'/customer/search',
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        )
        if (response.data.data && response.data.data.length === 0) {
          setCustomers([])
        } else {
          setCustomers(response.data.data)
          console.log('customer data', response.data.data)
        }
        setCustomers(response.data.data)
      } catch (err) {
        toast.error(
          err.response?.data?.message || 'No customers are available ',
        )
      } finally {
        setLoading(false)
      }
    }

    fetchCustomersData()
  }, [])

  return (
    <Container
      fluid className="px-3 pb-3"
    >
  
        {/* <Card.Header className=" text-success text-center bg-light">
          <h2 className="mb-2  fw-bold">Our Customers</h2>
        </Card.Header> */}

        <div className='px-2 mb-3' style={{ backgroundColor: theme.colors.background }}>
        
          <Table
            bordered
            hover
            responsive="md"
            className="text-center table table-bordered table-hover"
          >
            <thead className="position-sticky top-0  text-start">
                <tr className="text-start">
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Name</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Email</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Phone Number</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>City</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>My Bookings</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Action</th>
                </tr>
                
            </thead>
            <tbody className="text-start">
              {loading ? (
                <tr>
                  <td colSpan={7} className="text-center">
                    Loading customers...
                  </td>
                </tr>
              ) : customers.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center text-danger ">
                    No customers are available
                  </td>
                </tr>
              ) : null}

              {customers.map(
                (customer) =>
                  customer.name != null && (
                    <tr key={customer._id}>
                      <td>
                        {customer.title}
                        {'.'} {customer.name}
                      </td>
                      <td>{customer.email}</td>
                      <td>{customer.phone_number}</td>
                      <td>{customer.city}</td>
                      <td>
                        <Link to={`/BookingPlotDetails/${customer.id}`}>
                          Click
                        </Link>
                      </td>
                      <td>
                        {/* Updation using a particular user by given its ID */}
                        <Link
                          to={`/updatecustomer/${customer.id}`}
                          className="btn btn-outline-success btn-sm me-4"
                          title="Edit Customer"
                          style={
                            isHovered === customer.id
                              ? { ...buttonStyle, ...buttonHoverstyle }
                              : buttonStyle
                          }
                          onMouseEnter={() => setIsHovered(customer.id)}
                          onMouseLeave={() => setIsHovered(null)}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </Link>
                      </td>
                    </tr>
                  ),
              )}
            </tbody>
          </Table>
        </div>
      
    </Container>
  )
}

export default CustomerList
